import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { SiteFooter } from '../components/SiteFooter';

const LAST_UPDATED = '18 de mayo de 2025';
const COMPANY = 'ZettaPost';
const NIF = '70941839';
const EMAIL = 'hola@zettapost.com';
const ADDRESS = 'Calle Consuelo 20, Oficina 3, 37001 Salamanca (España)';
const DOMAIN = 'zettapost.com';

export function Privacy() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-14">

        {/* header */}
        <div className="mb-10">
          <p className="text-xs uppercase tracking-widest text-brand-600 font-semibold mb-2">Legal</p>
          <h1 className="text-3xl font-extrabold text-slate-900">Política de Privacidad</h1>
          <p className="mt-2 text-sm text-slate-400">Última actualización: {LAST_UPDATED}</p>
        </div>

        <div className="prose prose-slate max-w-none space-y-10">

          <Section title="1. Responsable del tratamiento">
            <p>El responsable del tratamiento de los datos personales recogidos a través de <strong>{DOMAIN}</strong> es:</p>
            <ul>
              <li><strong>Razón social:</strong> {COMPANY}</li>
              <li><strong>NIF:</strong> {NIF}</li>
              <li><strong>Domicilio:</strong> {ADDRESS}</li>
              <li><strong>Correo electrónico:</strong> <a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
            </ul>
          </Section>

          <Section title="2. Datos que recopilamos">
            <p>Recopilamos los siguientes datos personales cuando utilizas nuestros servicios:</p>
            <ul>
              <li><strong>Datos de registro:</strong> nombre, dirección de correo electrónico y contraseña (almacenada en formato cifrado).</li>
              <li><strong>Datos de redes sociales:</strong> tokens de acceso y metadatos de las cuentas que conectas voluntariamente (Instagram, X, LinkedIn, Facebook, TikTok, YouTube, Pinterest, Threads, Bluesky).</li>
              <li><strong>Contenido generado:</strong> publicaciones, textos, imágenes y vídeos que subes o programas a través de la plataforma.</li>
              <li><strong>Datos de uso:</strong> registros de acceso, dirección IP, tipo de navegador, páginas visitadas y acciones realizadas en la plataforma.</li>
              <li><strong>Datos de facturación:</strong> en caso de contratación de un plan de pago, los datos de facturación necesarios (gestionados por el procesador de pagos, sin que {COMPANY} almacene datos de tarjeta).</li>
            </ul>
          </Section>

          <Section title="3. Finalidad del tratamiento">
            <p>Tratamos tus datos para las siguientes finalidades:</p>
            <ul>
              <li>Prestación y mantenimiento del servicio de programación y publicación de contenidos en redes sociales.</li>
              <li>Gestión de tu cuenta de usuario y autenticación.</li>
              <li>Comunicaciones relacionadas con el servicio (confirmaciones, alertas técnicas, actualizaciones importantes).</li>
              <li>Atención al cliente y resolución de incidencias.</li>
              <li>Mejora del producto mediante análisis de uso agregado y anónimo.</li>
              <li>Cumplimiento de obligaciones legales y fiscales.</li>
            </ul>
          </Section>

          <Section title="4. Base jurídica del tratamiento">
            <p>El tratamiento de tus datos se sustenta en las siguientes bases legales conforme al Reglamento General de Protección de Datos (RGPD):</p>
            <ul>
              <li><strong>Ejecución de un contrato</strong> (art. 6.1.b RGPD): los datos necesarios para prestar el servicio contratado.</li>
              <li><strong>Consentimiento</strong> (art. 6.1.a RGPD): para el envío de comunicaciones comerciales o newsletters, cuando así lo hayas indicado expresamente.</li>
              <li><strong>Interés legítimo</strong> (art. 6.1.f RGPD): para la detección de fraude, seguridad y análisis de uso interno.</li>
              <li><strong>Obligación legal</strong> (art. 6.1.c RGPD): para el cumplimiento de obligaciones fiscales y contables.</li>
            </ul>
          </Section>

          <Section title="5. Conservación de los datos">
            <p>Conservamos tus datos mientras mantengas una cuenta activa en {COMPANY}. Una vez que solicites la cancelación de tu cuenta:</p>
            <ul>
              <li>Tus datos de contenido (publicaciones, imágenes) se eliminan de forma definitiva en un plazo máximo de <strong>30 días</strong>.</li>
              <li>Los datos de facturación y registros de transacciones se conservan durante <strong>5 años</strong> para el cumplimiento de obligaciones fiscales.</li>
              <li>Los registros de acceso se conservan durante <strong>12 meses</strong> por motivos de seguridad.</li>
            </ul>
          </Section>

          <Section title="6. Comunicación de datos a terceros">
            <p>No vendemos ni cedemos tus datos personales a terceros con fines comerciales. Únicamente los compartimos con:</p>
            <ul>
              <li><strong>Proveedores de infraestructura:</strong> Amazon Web Services (almacenamiento de archivos media en S3, región us-east-1).</li>
              <li><strong>Plataformas de redes sociales:</strong> exclusivamente para publicar el contenido que tú programas, mediante las APIs oficiales de cada red.</li>
              <li><strong>Procesadores de pago:</strong> para gestionar suscripciones de pago, bajo sus propias políticas de privacidad.</li>
              <li><strong>Autoridades competentes:</strong> cuando estemos legalmente obligados a ello.</li>
            </ul>
            <p>Todos nuestros proveedores están sujetos a acuerdos de tratamiento de datos conformes al RGPD.</p>
          </Section>

          <Section title="7. Transferencias internacionales">
            <p>Algunos de nuestros proveedores (Amazon Web Services) almacenan datos en servidores ubicados en Estados Unidos. Estas transferencias se realizan al amparo de las garantías adecuadas previstas en el RGPD, incluyendo las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea.</p>
          </Section>

          <Section title="8. Tus derechos">
            <p>Como titular de los datos, tienes derecho a:</p>
            <ul>
              <li><strong>Acceso:</strong> obtener confirmación de si tratamos tus datos y, en su caso, acceder a ellos.</li>
              <li><strong>Rectificación:</strong> solicitar la corrección de datos inexactos o incompletos.</li>
              <li><strong>Supresión:</strong> solicitar la eliminación de tus datos cuando ya no sean necesarios.</li>
              <li><strong>Oposición:</strong> oponerte al tratamiento basado en interés legítimo.</li>
              <li><strong>Limitación:</strong> solicitar que restrinjamos el tratamiento en determinadas circunstancias.</li>
              <li><strong>Portabilidad:</strong> recibir tus datos en un formato estructurado y legible por máquina.</li>
              <li><strong>Retirada del consentimiento:</strong> en cualquier momento, sin que ello afecte a la licitud del tratamiento previo.</li>
            </ul>
            <p>Para ejercer cualquiera de estos derechos, escríbenos a <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. Responderemos en el plazo máximo de <strong>30 días</strong>. También tienes derecho a presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong> en <a href="https://www.aepd.es" target="_blank" rel="noreferrer">www.aepd.es</a>.</p>
          </Section>

          <Section title="9. Seguridad">
            <p>{COMPANY} aplica medidas técnicas y organizativas apropiadas para proteger tus datos frente al acceso no autorizado, pérdida o destrucción, incluyendo:</p>
            <ul>
              <li>Cifrado de contraseñas con bcrypt (coste 12).</li>
              <li>Comunicaciones cifradas mediante TLS/HTTPS.</li>
              <li>Almacenamiento de archivos en buckets privados de S3 con acceso firmado.</li>
              <li>Sesiones autenticadas con cookies HttpOnly y Secure.</li>
              <li>Acceso restringido a la base de datos por red privada.</li>
            </ul>
          </Section>

          <Section title="10. Cookies">
            <p>{COMPANY} utiliza exclusivamente una cookie de sesión técnica necesaria para el funcionamiento del servicio (<code>zettapost.sid</code>). No utilizamos cookies de seguimiento, publicidad ni analítica de terceros. Al usar el servicio, aceptas el uso de esta cookie técnica imprescindible.</p>
          </Section>

          <Section title="11. Menores de edad">
            <p>El servicio de {COMPANY} no está dirigido a menores de 16 años. No recopilamos conscientemente datos de menores. Si detectas que un menor ha proporcionado datos sin consentimiento, contáctanos en <a href={`mailto:${EMAIL}`}>{EMAIL}</a> y procederemos a eliminarlos.</p>
          </Section>

          <Section title="12. Cambios en esta política">
            <p>Podemos actualizar esta Política de Privacidad ocasionalmente. Cuando lo hagamos, actualizaremos la fecha de "última actualización" en la parte superior de esta página y, si los cambios son significativos, te lo notificaremos por correo electrónico.</p>
          </Section>

          <Section title="13. Contacto">
            <p>Para cualquier consulta sobre esta política o sobre el tratamiento de tus datos:</p>
            <ul>
              <li><strong>Email:</strong> <a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
              <li><strong>Dirección postal:</strong> {ADDRESS}</li>
            </ul>
          </Section>

        </div>

        {/* footer nav */}
        <div className="mt-14 pt-6 border-t border-slate-200 flex flex-wrap gap-4 text-sm text-slate-500">
          <Link to="/" className="hover:text-slate-700">← Volver al inicio</Link>
          <Link to="/terms" className="hover:text-slate-700">Términos y condiciones</Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="text-lg font-bold text-slate-900 mb-3">{title}</h2>
      <div className="space-y-3 text-slate-600 text-sm leading-relaxed [&_a]:text-brand-600 [&_a]:hover:underline [&_ul]:mt-2 [&_ul]:space-y-1.5 [&_ul]:pl-5 [&_ul]:list-disc [&_strong]:text-slate-800 [&_code]:bg-slate-100 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-xs [&_code]:font-mono">
        {children}
      </div>
    </section>
  );
}
